import { Paper, Divider } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2.5),
    borderRadius: 10,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    backgroundColor: '#FFF',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  cardItem: {
    display: 'flex',
    marginTop: theme.spacing(0.5),
    alignItems: 'center',
  },
  cardItemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
    },
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
    display: 'inline-block',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    gap: 10,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}));

const ClassesCardSkeleton = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <div className={classes.cardItemHeader}>
        <Skeleton variant="text" width="60%" height={28} className={classes.skeletonColor} />
        <Skeleton variant="rect" width={36} height={36} className={classes.skeletonColor} style={{ borderRadius: 8 }} />
      </div>
      {[...Array(11)].map((_, i) => (
        <div key={i} className={classes.cardItem}>
          <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
          <Skeleton variant="text" width="60%" height={18} className={classes.skeletonColor} />
        </div>
      ))}
      <Divider className={classes.divider} />
      <div className={classes.buttons}>
        <Skeleton variant="rect" width="100%" height={40} className={classes.skeletonColor} style={{ borderRadius: 10 }} />
        <Skeleton variant="rect" width="100%" height={40} className={classes.skeletonColor} style={{ borderRadius: 10 }} />
      </div>
    </Paper>
  );
};

export default ClassesCardSkeleton; 